export default __webpack_public_path__ + "static/media/hht1_ani_15.a1dbdcc0.png";